import type { SceneMeta } from '@/types';

export const offshoreMeta: SceneMeta = {
  id: 'offshore',
  name: '海上钻井平台',
  shortName: '钻井平台',
  icon: '🏗️',
  thumbnail: '/scenes/offshore.jpg',
  description: '深海半潜式钻井平台3D全景：井架/隔水管/防喷器/泥浆循环/固井压井，海浪汹涌中的钢铁巨兽',
  designSize: { width: 1280, height: 760 },
  primaryColor: '#0ea5e9',
  difficulty: 'advanced',
  status: 'available',
  is3D: true,
};
